import { useState } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { getAssessmentIdAPIresponse } from "../../services";
import RenderLoading from "./partials/renderLoading";
import { STATIC_STRINGS } from "@asez/shared";

function CreateAssessment() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const handleCreateAssessment = async () => {
    setLoading(true);
    const assessmentId = await getAssessmentIdAPIresponse();
    navigate(`/edit/${assessmentId}`);
  };

  if (loading) {
    return <RenderLoading />;
  }

  return (
    <div
      className={classNames("create-assessment", "card-hover", "row")}
      onClick={handleCreateAssessment}
    >
      <div className="col-12 h-[40%] text-neutral-dark">
        <div className=" flex  items-center h-full text-5xl xl:text-7xl">
          <AddCircleOutlineIcon fontSize="inherit" color="inherit" />
        </div>
      </div>
      <div className="col-12 h-10 text-xl sm:text-base lg:text-lg xl:text-2xl xl:font-extrabold  font-bold text-primary truncate">
        {STATIC_STRINGS.CREATE_NEW_ASSESSMENT_TITLE}
      </div>
      <div className="col-12 h-10 text-sm xl:text-base xl:h-20 text-textColor-subtitle overflow-hidden line-clamp-2 ">
        {STATIC_STRINGS.CREATE_NEW_ASSESSMENT_DESC}
      </div>
    </div>
  );
}

export default CreateAssessment;
